
import { productCategoryImages } from '../../../utils/images';
import CraftsmanshipSection from './CraftsmanshipSection';
import { Link } from 'react-router-dom';

export default function ProductsOverview() {
  const products = [
    {
      title: "LEATHER GARMENTS",
      subtitle: "Premium sheepskin, lambskin, and cowhide with advanced finishes",
      image: productCategoryImages.leatherJackets,
      link: "/products/leather-garments"
    },
    {
      title: "SHEARLING OUTERWEAR",
      subtitle: "Natural shearling option for excellent warmth",
      image: productCategoryImages.shearling,
      link: "/products/shearling"
    },
    {
      title: "PU & FAUX FUR",
      subtitle: "Vegan-friendly alternatives with wide variety of textures",
      image: productCategoryImages.puFauxFur,
      link: "/products/pu-faux-fur"
    },
    {
      title: "PUFFER",
      subtitle: "Performance-driven outerwear for functionality and style",
      image: productCategoryImages.downJackets,
      link: "/products/puffer"
    }
  ];

  return (
    <>
      <section className="py-0 bg-white pb-16">
        <div className="max-w-full mx-auto">
          {/* Introduction */}

          {/* Products Grid - 4 Columns */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0">
            {products.map((product, index) => (
              <Link key={index} to={product.link}>
                <div
                  className="relative bg-cover bg-center group cursor-pointer overflow-hidden"
              style={{
                height: '500px',
                backgroundImage: `url(${product.image})`
              }}
              >
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-all duration-300"></div>
                <div className="relative z-10 h-full flex flex-col justify-center items-center text-center text-white px-6">
                  <h3 className="text-[20px] mb-3 tracking-wide leading-tight">
                    {product.title}
                  </h3>
                  <p className="text-sm opacity-90 max-w-xs leading-relaxed">
                    {product.subtitle}
                  </p>
                  <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="inline-block px-4 py-2 bg-white text-black text-sm font-medium tracking-wide">
                      EXPLORE MORE
                    </span>
                  </div>
                </div>
              </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Craftsmanship Section */}
      <CraftsmanshipSection />
    </>
  );
}
